__turbopack_context__.v({
  "root": "styles-module-scss-module__Vgw9yG__root",
  "section": "styles-module-scss-module__Vgw9yG__section",
});
